import React, { useCallback, useRef, useState, useReducer } from 'react';
import { VIEW_SMS_SEND } from '../../../constant/ViewConstant';
import BreadCrumb from '../../../component/BreadCrumb';
import PopupRef from '../../../component/PopupRef';
import ModalRef from '../../../component/ModalRef';
import InputBox from '../../../component/InputBox';
import TextAreaBox from '../../../component/TextAreaBox';
import SelectionBox from '../../../component/SelectionBox';
import { CODE_GROUP_ID } from '../../../constant/Constant';
import CodeUtil from '../../../util/CodeUtil';
import {
    AddButtonBox,
    DownloadButtonBox,
    UploadButtonBox,
    DeleteAllButtonBox,
    SendTestButtonBox,
    SendButtonBox,
} from '../../../component/buttons/SmsButtonBox';
import { Chip } from '@material-ui/core';
import SmsSendTestModal from '../../modal/SmsSendTestModal';
import TelNoInputBox from '../../../component/TelNoInputBox';
import NullCheckUtil from '../../../util/NullCheckUtil';
import readXlsxFile from 'read-excel-file';
import SmsSendUserSearchView from './SmsSendUserSearchView';
import FormatUtil from '../../../util/FormatUtil';
import { actionSetPhoneData, actionSmsSend, actionSampleExcelDownload } from '../../../module/body/sms/SmsSendModule';
import { useDispatch, useSelector } from 'react-redux';

const SEND_TYPE_SMS = 'SMS';
const SEND_TYPE_LMS = 'LMS';

// msg 의 길이 구해야 함.
const calcMsgLen = (msg) => {
    // UTF8에서 한글 3byte이므로 encode 의 길이는 6임
    let str = msg;
    var len = 0;
    for (var i = 0; i < str.length; i++) {
        if (encodeURI(str.charAt(i)).length >= 4) {
            len++;
        }
        len++;
    }
    return len;
};

// --------------------------------------------------------------
//  SMS 발송 기능 화면
// -------------------------------------------------------------
const SmsLeftArea = ({ state, dispatch }) => {
    const { sendTypeCd, callback, title, msg } = state;

    const onchange = (name, value) => {
        dispatch({ name, value });
    };

    return (
        <>
            <div className='con-tb-title'>
                <h3 className='tb-tit-name'>발송정보 및 메시지</h3>
            </div>
            <div className='comment-box'>
                <ul>
                    <li>SMS : 최대 90byte/한글45자</li>
                    <li>LMS : 최대 2000byte/한글 1000자</li>
                    <li>LMS 제목 사용가능, 최대 40byte/한글 20자</li>
                </ul>
            </div>
            <div className='sms-box'>
                <div className='form-box-row'>
                    <SelectionBox
                        title='발송 유형'
                        value={sendTypeCd}
                        options={CodeUtil.getCodes(CODE_GROUP_ID.SMS_SEND_TYPE)}
                        onChange={(e) => onchange('sendTypeCd', e.target.value)}
                        useAll={false}
                    />
                </div>
                {sendTypeCd == SEND_TYPE_SMS ? (
                    <></>
                ) : (
                    <div className='form-box-row'>
                        <InputBox
                            title='제목'
                            value={title}
                            placeholder='LMS 발송 제목을 입력하세요.'
                            onChange={(e) => onchange('title', e.target.value)}
                        />
                    </div>
                )}

                <div className='form-box-row'>
                    <TextAreaBox
                        title='발송 메시지'
                        value={msg}
                        placeholder='발송 메시지를 입력하세요.'
                        onChange={(e) => onchange('msg', e.target.value)}
                    />
                    <div className='sms-msg-size'>
                        {calcMsgLen(msg)} / {sendTypeCd == SEND_TYPE_SMS ? '90 byte' : '2000 byte'}
                    </div>
                </div>
                <div className='form-box-row'>
                    <SelectionBox
                        title='발송 번호'
                        value={callback}
                        options={CodeUtil.getCodes(CODE_GROUP_ID.SMS_CALLING_NUMBER)}
                        onChange={(e) => onchange('callback', e.target.value)}
                        useAll={false}
                    />
                </div>
            </div>
        </>
    );
};

const SmsRightTopArea = ({ state, modalRef, popupRef }) => {
    const [phone, setPhone] = useState('');
    const { phoneData } = useSelector((state) => state.smsSendState);
    const dispatch = useDispatch();
    const { sendTypeCd, callback, title, msg } = state;

    // 수신번호 추가
    const handleAddPhone = useCallback(
        (phone) => {
            console.log('* handleAddPhone : ' + phone);
            console.log('* 등록된 번호 목록 : ' + phoneData);

            if (NullCheckUtil.isEmpty(phone) || phone.length != 11) {
                popupRef.current.openAlert('올바른 번호를 입력하세요.');
                return false;
            }

            let isDuplicate = phoneData.some((item) => item == phone);

            if (isDuplicate) {
                console.log('* isDuplicate : ' + isDuplicate);
                popupRef.current.openAlert('이미 등록된 번호입니다.');
                return false;
            } else {
                dispatch(
                    actionSetPhoneData({
                        data: {
                            job: 'add',
                            phone,
                        },
                    }),
                );
                return true;
            }
        },
        [phoneData],
    );

    const checkSendType = () => {
        if (sendTypeCd == SEND_TYPE_SMS && calcMsgLen(msg) > 90) {
            popupRef.current.openAlert('90byte를 초과합니다. 발송타입을 LMS변경하거나 메시지를 조정하세요.');
            return false;
        } else if (sendTypeCd == SEND_TYPE_LMS) {
            if (NullCheckUtil.isEmpty(title)) {
                popupRef.current.openAlert('제목을 입력해 주세요.');
                return false;
            }

            if (calcMsgLen(msg) > 2000) {
                popupRef.current.openAlert('LMS로 발송 가능한 최대 사이즈는 2000byte입니다.');
                return false;
            }
        }

        if (calcMsgLen(msg) <= 0) {
            popupRef.current.openAlert('발송 메시지를 입력해 주세요.');
            return false;
        }

        if (NullCheckUtil.isEmpty(callback)) {
            popupRef.current.openAlert('회신번호를 입력해 주세요.');
            return false;
        }

        return true;
    };

    const onKeyDown = (e, phone) => {
        if (e.key == 'Enter') {
            handleAddPhone(phone);
        }
    };

    const handleSampleDownload = () => {
        console.log('* handleSampleDownload');
        dispatch(actionSampleExcelDownload({}));
    };

    const handleAddPhoneList = useCallback(
        (file, popupRef) => {
            let phoneList = [];
            let successCnt = 0;
            let failList = [];
            readXlsxFile(file).then((sheets) => {
                sheets.map((array, index) => {
                    if (index === 0) {
                        return;
                    }
                    const phone = array[0].replaceAll('-', '');

                    if (phoneList.some((item) => item === phone)) {
                        failList.push(index + 1);
                        return;
                    }

                    phoneList.push(phone);
                    const successYn = handleAddPhone(phone);

                    if (successYn) {
                        successCnt = successCnt + 1;
                    } else {
                        failList.push(index + 1);
                    }
                });

                let resultMsg = '';
                if (successCnt > 0) {
                    if (NullCheckUtil.isEmpty(failList)) {
                        resultMsg = '정상 처리 되었습니다.';
                    } else {
                        resultMsg = '업로드 성공 건수 : [' + successCnt + '], 실패 라인(엑셀파일) : [' + failList + ']';
                    }
                } else {
                    if (NullCheckUtil.isEmpty(failList)) {
                        resultMsg = '처리된 데이터가 없습니다. 샘플 파일을 확인해 주세요.';
                    } else {
                        resultMsg = '실패 라인(엑셀파일) : [' + failList + ']';
                    }
                }

                popupRef.current.openAlert(resultMsg);
            });
        },
        [phoneData],
    );

    // 수신번호 전체삭제
    const handleDeleteAllPhone = () => {
        console.log('* handleDeleteAllPhone');
        dispatch(
            actionSetPhoneData({
                data: {
                    job: 'allDel',
                    phone: [],
                },
            }),
        );
    };

    // Chip의 특정 수신번호 삭제
    const handleDeletePhone = (phone) => {
        console.log('* handleDeletePhone : ' + phone);
        dispatch(
            actionSetPhoneData({
                data: {
                    job: 'del',
                    phone,
                },
            }),
        );
    };

    const handleSendTest = () => {
        console.log('* handleTestSend');

        if (checkSendType()) {
            modalRef.current.open(<SmsSendTestModal state={state} modalRef={modalRef} popupRef={popupRef} />, 'small');
        }
    };

    const handleSend = () => {
        console.log('* handleSend');

        if (NullCheckUtil.isEmpty(phoneData)) {
            popupRef.current.openAlert('수신번호를 추가해 주세요.');
            return false;
        }

        if (checkSendType()) {
            dispatch(
                actionSmsSend({
                    data: {
                        sendTypeCd,
                        callback: FormatUtil.removeTelNoFormat(callback),
                        title: sendTypeCd === SEND_TYPE_LMS ? title : '',
                        msg,
                        phoneList: phoneData,
                    },
                    callback: (result) => {
                        popupRef.current.openAlert(
                            '성공 건수 : [' + result.success + '], 실패 건수 : [' + result.failure + ']',
                        );
                    },
                }),
            );
        }
    };

    return (
        <>
            <div className='con-tb-title'>
                <h3 className='tb-tit-name'>수신자 등록 및 발송</h3>
            </div>
            <div className='comment-box'>
                <ul>
                    <li>
                        수신자를 직접 입력하여 추가하거나, 엑셀 업로드하여(샘플 다운로드하여 작성) 일괄 추가할 수
                        있습니다.
                    </li>
                    <li>
                        하단의 검색을 이용하여 소속대학 및 개설대학의 수강학생을 조회하고 수신자를 추가할 수 있습니다.
                    </li>
                </ul>
            </div>
            <div className='phone-box'>
                <div className='phone-box-input-row'>
                    <TelNoInputBox
                        title='수신번호'
                        value={phone}
                        setTelNo={setPhone}
                        onKeyDown={(e) => onKeyDown(e, phone)}
                    />
                    <div className='btn-group'>
                        <AddButtonBox onClick={(e) => handleAddPhone(phone)} />
                        <DownloadButtonBox onClick={(e) => handleSampleDownload()} />
                        <UploadButtonBox
                            callback={(file) => {
                                handleAddPhoneList(file, popupRef);
                            }}
                        />
                    </div>
                </div>
                <div className='phone-box-info-row'>
                    <div className='info-txt'>수신자 : {phoneData.length} 명</div>
                    <DeleteAllButtonBox onClick={(e) => handleDeleteAllPhone()} />
                </div>
                <div className='phone-box-list-row'>
                    {phoneData &&
                        phoneData.map((item, index) => (
                            <React.Fragment key={index}>
                                <div className='phone-item-chip'>
                                    <Chip
                                        color='primary'
                                        size='small'
                                        label={FormatUtil.phoneFormatter(item)}
                                        onDelete={() => handleDeletePhone(item)}
                                    />
                                </div>
                            </React.Fragment>
                        ))}
                </div>
                <div className='phone-box-btn-row'>
                    <div className='btn-wrap'>
                        <SendTestButtonBox onClick={(e) => handleSendTest()} />
                        <SendButtonBox onClick={(e) => handleSend()} />
                    </div>
                </div>
            </div>
        </>
    );
};

const SmsRightBottomArea = ({ modalRef, popupRef }) => {
    return <SmsSendUserSearchView modalRef={modalRef} popupRef={popupRef} />;
};

function reducer(state, action) {
    return {
        ...state,
        [action.name]: action.value,
    };
}

const SmsSendView = () => {
    const modalRef = useRef(null);
    const popupRef = useRef(null);
    const [state, dispatch] = useReducer(reducer, {
        sendTypeCd: SEND_TYPE_SMS,
        callback: CodeUtil.getFirstCode(CODE_GROUP_ID.SMS_CALLING_NUMBER),
        title: '',
        msg: '',
    });

    return (
        <section className='container'>
            <div className='container-inner'>
                <div className='con-title-wrap conbg05'>
                    <h2 className='con-title'>{VIEW_SMS_SEND.title}</h2>
                    <p className='con-title-p'>{VIEW_SMS_SEND.subTitle}</p>
                </div>
                <div className='sub-nav-wrap'>
                    <BreadCrumb />
                </div>
                <div className='con-tb-wrap sms-send-wrap'>
                    <div className='left-box'>
                        <SmsLeftArea state={state} dispatch={dispatch} />
                    </div>
                    <div className='right-box'>
                        <div className='right-top-box'>
                            <SmsRightTopArea state={state} modalRef={modalRef} popupRef={popupRef} />
                        </div>
                        <div className='border-divider '></div>
                        <div className='right-bottom-box'>
                            <SmsRightBottomArea modalRef={modalRef} popupRef={popupRef} />
                        </div>
                    </div>
                </div>
            </div>
            <PopupRef ref={popupRef} />
            <ModalRef ref={modalRef} />
        </section>
    );
};

export default SmsSendView;
